import React from 'react';
import classNames from 'classnames';
import { DATE_TYPES } from '../common/constants';
import { isMobile } from '../utils';
import { ChatContextType } from '../common/type';
import styles from './index.module.scss';

type Props = {
  chatContext: ChatContextType;
  currentDateOption?: number;
  onSelectDateOption: (value: number) => void;
};

const DateOptions: React.FC<Props> = ({ chatContext, currentDateOption, onSelectDateOption }) => {
  const dateOptions = DATE_TYPES[chatContext?.dateInfo?.period] || DATE_TYPES.DAY;

  return (
    <div className={styles.dateOptions}>
      {dateOptions.map((dateOption: { label: string; value: number }, index: number) => {
        const dateOptionClass = classNames(styles.dateOptionsItem, {
          [styles.dateOptionsDateActive]: dateOption.value === currentDateOption,
          [styles.dateOptionsDateMobile]: isMobile,
        });
        return (
          <React.Fragment key={dateOption.value}>
            <div
              className={dateOptionClass}
              onClick={() => {
                onSelectDateOption && onSelectDateOption(dateOption.value);
              }}
            >
              {dateOption.label}
              {dateOption.value === currentDateOption && (
                <div className={styles.dateOptionsActiveIdentifier} />
              )}
            </div>
            {index !== dateOptions.length - 1 && <div className={styles.dateOptionsItemDivider} />}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default DateOptions;
